
import {
  defineComponent,
  ref,
  onMounted,
  watch,
} from 'vue';
import {
  message,
  Modal,
} from 'ant-design-vue';
import { useStore, } from 'vuex';
import authority from '@/components/authority/index.vue';

export default defineComponent({
  components: {
    Modal,
    authority,
  },
  props: {
    rightVisible: {
      type: Boolean,
      default: () => false,
      require: true,
    },
    roleType: {
      type: String,
      default: () => '',
      require: true,
    },
    roleId: {
      type: String,
      default: () => '',
      require: true,
    },
    roleData: {
      type: String,
      default: () => 'allData',
      require: true,
    },
  },
  setup (props, { emit, }) {
    const store = useStore();
    const rightInfolRef = ref<any>(null);
    const selectTab = ref<any>('basic');
    const selectTerminalTip = ref<boolean>(false);

    const checkedTerminal = (flag:boolean) => {
      if (flag) {
        selectTerminalTip.value = false;
      }
    };
    const handleCancle = () => {
      emit('RightCancal');
    };
    const handleSave = () => {
      const getTerminalSelected = rightInfolRef.value.getTerminalSelected();

      if (!getTerminalSelected || !getTerminalSelected.length) {
        selectTerminalTip.value = true;

        return;
      }

      const ticketRadioChecked = rightInfolRef.value.getTicketRadioChecked();

      if (!ticketRadioChecked) {
        return message.warning('请配置工单数据权限');
      }

      selectTerminalTip.value = false;

      const rightParams = rightInfolRef.value.getCurRights();
      const { dataType,menuIds, } = rightParams;

      const params = {
        roleId: props.roleId,
        menuIds,
        dataType,
      };

      store.dispatch('userCenter/changeRoleGrant', params).then(() => {
        emit('right-save');
      });
    };

    return {
      rightInfolRef,
      selectTab,
      selectTerminalTip,

      handleCancle,
      checkedTerminal,
      handleSave,
    };
  },
});
